import PropTypes from 'prop-types';
import React from 'react';

import { getAppProps } from '@pages/_app';
import { buildDataUrl } from '@helper/api';
import TemplateDefault from '../../templates/default/default';
import Stage from '../../organisms/stage/stage';
import NewsroomSection from '../../organisms/newsroom-section/newsroomSection';

const Newsroom = ({ data }) => {
  const { content } = data;

  return (
    <TemplateDefault>
      <Stage />

      {content && content.map((section, index) => <NewsroomSection key={index} {...section} />)}
    </TemplateDefault>
  );
};

Newsroom.propTypes = {
  data: PropTypes.shape().isRequired
};

const getNewsroomProps = async ({ locale, category, slug }) => {
  const getPageProps = await fetch(
    buildDataUrl(
      `${locale}/${process.env.NEXT_PUBLIC_JSON_API_PATH}/${category ? `${category}/${slug}` : slug}`
    )
  )
    .then(res => res.json())
    .catch(err => console.error('about-us/newsroom.jsx ', err));

  const [appProps, data] = await Promise.allSettled([getAppProps({ locale }), getPageProps]).then(
    results => results.map(result => result.value)
  );

  return {
    PAGE_TYPE: 'NEWSROOM',
    ...appProps,
    ...data
  };
};

export default Newsroom;
export { getNewsroomProps };
